var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({staticClass:"back-button",attrs:{"icon":""},on:{"click":function($event){_vm.target && _vm.$router.push(_vm.target)}}},_vm.listeners),[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }